import { ReactNode } from 'react';

export const WidePageLayout = ({ children }: { children: ReactNode }) => {
  return <div className="flex-1 p-8 mx-auto w-full max-w-7xl">{children}</div>;
};
